import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { PagedSoftwareSettingsMetadataList, SettingsTypeEnumSchema, SoftwareEnumSchema } from "@domain/schemas/BI";

@injectable()
export class ListSoftwareSettingsService {
  @inject(TYPES.ISoftwareSettingsRepository)
  private _softwareSettingsRepository!: ISoftwareSettingsRepository;

  async getSettingsListAsync(
    projectId: string,
    settingsType: SettingsTypeEnumSchema,
    software?: SoftwareEnumSchema,
    folder?: string | null,
    sourcePath?: string | null,
  ): Promise<PagedSoftwareSettingsMetadataList> {
    return this._softwareSettingsRepository.GetListAsync(projectId, settingsType, software, folder, sourcePath);
  }
}
